import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ImportsPageRoutingModule } from './imports-routing.module';

import { ImportsPage } from './imports.page';
import { ReceiveRecognizeComponent } from 'src/app/modules/recognize-team/modals/receive-recognize/receive-recognize.component';
import { RecognizeByPageModule } from 'src/app/modules/recognize-team/recognize-by/recognize-by.module';
import { ViewEmployeeVoicePageModule } from 'src/app/modules/employee-voice/view-employee-voice/view-employee-voice.module';


@NgModule({
  entryComponents: [
    ReceiveRecognizeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImportsPageRoutingModule,
    ViewEmployeeVoicePageModule,
    RecognizeByPageModule
  ],
  declarations: [
    ImportsPage,
    ReceiveRecognizeComponent
  ]
})
export class ImportsPageModule {}
